import { render } from "./Recaptcha.vue?vue&type=template&id=33253cea&scoped=true"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"

import "./Recaptcha.vue?vue&type=style&index=0&id=33253cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33253cea"]])

export default __exports__